import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import {map, switchMap, withLatestFrom} from 'rxjs/operators';
import {of} from 'rxjs';
import * as featureActions from '../../index';
import {Store} from '@ngrx/store';
import * as fromStore from '../../../store';
import {RegionService} from '../../../services/region.service';

@Injectable()
export class MspMemberAuthorityEffects {
  private actions$ = inject(Actions);
  private store$ = inject(Store<fromStore.State>);
  private regionService = inject(RegionService);

  constructor() {}

  GetMspMemberRegions$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.RegionMspMemberActionTypes.GetMspMemberRegions),
    map((action: featureActions.GetMspMemberRegions) => action.payload),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([payload, user]) => {
        const params = {
        otp: user.otp
      };
      return this.regionService.ReadProMmemberAuthority(params).pipe(
        switchMap((res: any) => {
          if (res.result) {
            return [new featureActions.GetMspMemberRegionSuccess(res.msg.body)];
          } else {
            return of(new featureActions.GetMspMemberRegionFail());
          }
        })
      );
    })
  ));
}
